import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { useWatch } from "react-hook-form";
import ReactJson from "@microlink/react-json-view";

function RawApiData() {
  const watchRawApiData = useWatch({ name: "raw_api_data" });
  return (
    <Card style={{ maxWidth: 800 }}>
      <CardBody style={{ padding: 16 }}>
        {typeof watchRawApiData === "object" && watchRawApiData != null ? (
          <ReactJson collapsed={true} src={watchRawApiData} />
        ) : null}
      </CardBody>
    </Card>
  );
}

export default RawApiData;
